<template>
  <div>
    <SysDialogFullScreen v-model="dialog">
      <template #titulo>
        <v-btn icon class="ml-n2 mr-5" dark @click="fecharDialog(true)">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-flex xs4 style="height: 50px">
          <v-toolbar-title class="fw-bold">
            <v-icon color="#FFF">mdi-cart</v-icon>
            Cotacão do carrinho
            <span :title="pedido.idpedido">#{{ pedido.idpedido || '' }}</span>
          </v-toolbar-title>

          <p v-if="DATA_ABERTURA_COMPUTED" class="ma-0 mt-n2 font-14 font-weight-regular">
            Aberto em {{ DATA_ABERTURA_COMPUTED }}
          </p>
        </v-flex>

        <v-spacer />

        <RelatorioCotacao :pedido="pedido" :cotacao="COTACAO"/>

        <v-spacer />

        <div class="text-right">
          <p class="my-0 font-16">
            <strong>Total: </strong>
            R$ {{ Helpers.formatarValorComCasas(TOTAL, 2) }}
          </p>

          <p class="my-0 mt-n2 font-16">
            <strong>Saving: </strong>
            <span v-if="(SAVING > 0 )" style="color: #00e900">R$ {{ Helpers.formatarValorComCasas(Math.abs(SAVING), 2) }}</span>
            <span v-else-if="(SAVING < 0 )" style="color: red">(R$ {{ Helpers.formatarValorComCasas(Math.abs(SAVING), 2) }})</span>
            <span v-else>R$ {{ Helpers.formatarValorComCasas(Math.abs(SAVING), 2) }}</span>
          </p>
        </div>
      </template>

      <MenuContexto>
        <template #menu-de-opcoes>
          <v-list class="font-14">
            <AdicionarProdutosCotacaoPedido
              :parametros="{...pedido, ...GET_COTACOES_ID_PEDIDO[tab]}"
              @fechar-dialog-anterior="fecharDialog()"
              @abrir-dialog-anterior="buscarCotacaoPedido(GET_COTACOES_ID_PEDIDO[tab].id_cotacao); abrirDialog();"
            />
          </v-list>
        </template>

        <v-card flat class="pa-1" v-if="(GET_COTACOES_ID_PEDIDO.length == 0)">
          <p class="text-center">Não possue cotações o pedido.</p>
        </v-card>

        <v-card flat class="pa-1" v-else>
          <v-tabs centered v-model="tab">
            <v-tab
              v-for="t in GET_COTACOES_ID_PEDIDO"
              :key="t.id_cotacao"
            >
              Cotação #{{ pedido.idpedido }}/{{ t.id_cotacao }}
            </v-tab>
          </v-tabs>

          <TabelaCotacaoPedido :pedido_selecionado="pedido" />
        </v-card>
      </MenuContexto>
    </SysDialogFullScreen>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import SysDialogFullScreen from '@/components/padraoDeLayout/SysDialogFullScreen.vue';
import MenuContexto from '@/components/utils/MenuContexto.vue';
import { abrirCotacaoPedido, buscarCotacaoPedido } from "./CotacaoApi";
import RelatorioCotacao from "./Relatorios/Index.vue";

import AdicionarProdutosCotacaoPedido from "./AdicionarProdutosCotacaoPedido";
import TabelaCotacaoPedido from "./TabelaCotacaoPedido";

export default {
  components: {
    SysDialogFullScreen,
    RelatorioCotacao,
    MenuContexto,
    AdicionarProdutosCotacaoPedido,
    TabelaCotacaoPedido
  },
  props: {
    pedido: {
      type: Object,
      required: true
    },
    ativacao_dialog_personalizada: {
      type: String,
      required: true,
      default: ''
    }
  },
  data () {
    return {
      dialog: false,
      tab: null
    }
  },
  computed: {
    ...mapGetters({
      GET_DIALOG_ABRIR_COTACAO: "CotacaoCarrinhoCompra/GET_DIALOG_ABRIR_COTACAO",
      GET_DIALOG_VER_COTACAO: "CotacaoCarrinhoCompra/GET_DIALOG_VER_COTACAO",
      getProdutosSelecionadosCarrinho: "CotacaoCarrinhoCompra/GET_PRODUTOS_SELECIONADOS_CARRINHO",
      GET_PRODUTOS_COTACAO_PEDIDO: "CotacaoCarrinhoCompra/GET_PRODUTOS_COTACAO_PEDIDO",
      GET_COTACOES_ID_PEDIDO: "CotacaoCarrinhoCompra/GET_COTACOES_ID_PEDIDO"
    }),
    TOTAL() {
      return this.GET_PRODUTOS_COTACAO_PEDIDO.reduce((r, b) => Number(r) + (Number(b.preco) * Number(b.quantidade)), 0);
    },
    SAVING() {
      return this.GET_PRODUTOS_COTACAO_PEDIDO.reduce((r, b) => Number(r) + (Number(b.preco_custo_base) * Number(b.quantidade)), 0) - this.TOTAL;
    },
    COTACAO() {
      if (this.tab != null && this.GET_COTACOES_ID_PEDIDO.length > 0 && this.GET_COTACOES_ID_PEDIDO[this.tab]) {
        return this.GET_COTACOES_ID_PEDIDO[this.tab];
      }

      return { id_cotacao: null };
    },
    DATA_ABERTURA_COMPUTED() {
      if (this.tab != null && this.GET_COTACOES_ID_PEDIDO[this.tab] && this.GET_COTACOES_ID_PEDIDO[this.tab].data_abertura) {
        return this.GET_COTACOES_ID_PEDIDO[this.tab].data_abertura;
      }

      return null;
    }
  },
  watch: {
    pedido() {
      this.buscarCotacaoPedido();
    },
    tab(valor) {
      if (typeof valor == 'number' && this.dialog) this.buscarCotacaoPedido(this.COTACAO.id_cotacao);
    },
    GET_DIALOG_ABRIR_COTACAO(valor) {
      if (valor && this.ativacao_dialog_personalizada == 'abrir') this.abrirCotacaoProdutosPedido();
    },
    GET_DIALOG_VER_COTACAO(valor) {
      if (valor && this.ativacao_dialog_personalizada == 'ver') {
        this.buscarCotacaoPedido();
        this.abrirDialog();
      }
    },
    GET_PRODUTOS_COTACAO_PEDIDO(valor) {
      if (valor.length == 0 && this.GET_COTACOES_ID_PEDIDO.length > 0) this.tab = 0;
    },
    'GET_COTACOES_ID_PEDIDO.length': function (length) {
      if (length === 0) {
        this.dialog = false;
        this.SET_DIALOG_ABRIR_COTACAO(false);
      }
    }
  },
  methods: {
    ...mapMutations({
      SET_PRODUTOS_COTACAO_PEDIDO: "CotacaoCarrinhoCompra/SET_PRODUTOS_COTACAO_PEDIDO",
      SET_COTACOES_ID_PEDIDO: "CotacaoCarrinhoCompra/SET_COTACOES_ID_PEDIDO",
      SET_PRODUTOS_SELECIONADOS_CARRINHO: "CotacaoCarrinhoCompra/SET_PRODUTOS_SELECIONADOS_CARRINHO",
      SET_RESETAR_PRODUTOS_SELECIONADOS_CARRINHO: "CotacaoCarrinhoCompra/SET_RESETAR_PRODUTOS_SELECIONADOS_CARRINHO",
      SET_DIALOG_ABRIR_COTACAO: "CotacaoCarrinhoCompra/SET_DIALOG_ABRIR_COTACAO",
      SET_DIALOG_VER_COTACAO: "CotacaoCarrinhoCompra/SET_DIALOG_VER_COTACAO",
      SET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO: "CotacaoCarrinhoCompra/SET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO"
    }),
    abrirDialog() {
      this.dialog = true;
    },
    fecharDialog(resetar_tab = false) {
      this.dialog = false;
      this.SET_DIALOG_VER_COTACAO(false);
      this.SET_DIALOG_ABRIR_COTACAO(false);
      this.SET_PRODUTOS_SELECIONADOS_COTACAO_PEDIDO([]);
      if (resetar_tab) this.tab = null;
    },
    buscarCotacaoPedido(id_cotacao = null) {
      this.$store.dispatch(
        "loading/addRequisicao",
        buscarCotacaoPedido(this.pedido.idpedido, id_cotacao)
          .then((c) => {
            this.SET_COTACOES_ID_PEDIDO(c.ids);
            this.SET_PRODUTOS_COTACAO_PEDIDO(c.produtos);

            if (c.ids > 0) this.tab = 0;
          })
          .catch(() => this.Helpers.logout())
      );
    },
    abrirCotacaoProdutosPedido() {
      const params = {
        pedido: this.pedido,
        produtos: this.getProdutosSelecionadosCarrinho
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        abrirCotacaoPedido(params)
          .then((c) => {
            if (c.length == 0) { return this.GET_COTACOES_ID_PEDIDO = 'Não possui cotação no momento para esse pedido!'; }

            this.SET_RESETAR_PRODUTOS_SELECIONADOS_CARRINHO();
            this.SET_COTACOES_ID_PEDIDO(c.ids);
            this.SET_PRODUTOS_COTACAO_PEDIDO(c.produtos);
            this.tab = this.GET_COTACOES_ID_PEDIDO.length - 1;

            this.abrirDialog();
          })
          .catch(() => this.Helpers.logout())
      );
    },
  }
}
</script>


